import { render, staticRenderFns } from "./CBaseSheet.vue?vue&type=template&id=5ba83846&"
var script = {}
import style0 from "./CBaseSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports